var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-row"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": _vm.filterId,
      "name": "checkbox-1"
    },
    domProps: {
      "checked": _vm.getValue
    },
    on: {
      "change": function (e) {
        return _vm.handleChange(e);
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.filterId
    }
  }, [_vm._v(_vm._s(_vm.label))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }